var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PlayerHeraList',{attrs:{"data-source":_vm.getTournamentsReplaced,"filters":_vm.filters,"dummy-props":{
      iconName: 'empty-competitions',
      headerText: _vm.$t(
        '_web_competitions_tournaments-list-empty',
        'There are no tournaments at the moment'
      ),
      text: _vm.$t(
        '_web_competitions_tournaments-list-empty-subheader',
        'Check the filters or come back later. Hope you find what you are looking for'
      ),
    },"filters-on-top":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var tournament = ref.item;
return _c('TournamentCard',_vm._b({staticClass:"h-100",attrs:{"is-tournament-page":true}},'TournamentCard',{ tournament: tournament },false))}}])},[_c('TextBlock',{staticClass:"mb-4",attrs:{"slot":"filterBefore","tag":"h1","size":1.5,"line-height":1.5},slot:"filterBefore"},[_vm._v("\n      "+_vm._s(_vm.$t(
          '_web_competitions_tournaments-list-subheader',
          'Current and upcoming tournaments'
        ))+"\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }